import { makeStyles, Popover, PopoverSurface, PopoverTrigger, tokens } from "@fluentui/react-components";
import type { GateTag } from "@/engine/types";
import { usePlanSurface } from "@/features/access/use-plan-access";
import { useProjectStore } from "@/store/project-store";
import { GatePanel } from "./GateChecklistSection";
import { GateTagChip } from "./GateTagChip";

const useStyles = makeStyles({ surface: { width: "340px", maxHeight: "60vh", overflowY: "auto", padding: tokens.spacingVerticalM } });

/** 칩을 누르면 화면 이동 없이 체크리스트 확인·검수 요청·Pass/Fail 판정을 한다. */
export function GateTagMicroPopover({ taskId, gate }: { taskId: string; gate: GateTag }) {
  const styles = useStyles();
  const surface = usePlanSurface();
  // the store copy is the truth; the prop may be a stale card snapshot
  const live = useProjectStore((s) => s.project.executionTasks.find((t) => t.id === taskId)?.gateTags?.find((g) => g.id === gate.id)) ?? gate;
  return (
    <Popover positioning="below-start" withArrow trapFocus>
      <PopoverTrigger disableButtonEnhancement>
        <GateTagChip gate={live} onClick={(e) => e.stopPropagation()} />
      </PopoverTrigger>
      <PopoverSurface className={styles.surface} onClick={(e) => e.stopPropagation()}>
        <GatePanel taskId={taskId} gate={live} compact readOnly={!surface.editTask} />
      </PopoverSurface>
    </Popover>
  );
}
